import { ALL_USERS, DEFAULT_ITEMS_PER_PAGE, DEFAULT_PAGE } from './constants';
import { AxiosHelper } from './ms-utils';

const BROADCAST = {
  LIST_ALL: '',
  BY_ID: id => `/id/${id}`,
  LIST_BY_CHILD_ID: childId => `/child/${childId}`,
  RECALL: id => `/recall/${id}`,
  SAVE: `/save`,
  MARK_READ: id => `/read/${id}`,
  DELETE: id => `/id/${id}`,
  UPLOAD_ATTACHMENT: schoolId =>
    `/attachment/get-signed-upload-url/${schoolId}`,
  GET_SIGNED_PRIVATE_URL: '/attachment/get-file-signed-access-url',
  GET_MS_CENTRE: '/get-accessible-centres',
  GET_MS_LEVEL: schoolId => `/level/school/${schoolId}`,
  SEARCH_SCOPE: '/search-scope/',
};

const NOTIFICATION = {
  LIST: '',
  MARK_READ: '/mark-as-read',
};

export const HEALTH_ATTENDANCE_ENDPOINT = {
  GET_CHECK_IN_OUT_TOKEN: '/attendance/check-in-out-token',
  GET_CENTRE_ATTENDANCE_SUMMARIES: '/attendance/centre-attendance-summaries',
  GET_CENTRE_ATTENDANCE_SUMMARIES_FOR_STAFF:
    '/attendance/centre-attendance-summaries-for-staff',
};

export const BROADCAST_ENDPOINT = BROADCAST;
export const NOTIFICATION_ENDPOINT = NOTIFICATION;
export const CENTRE_SVC_ENDPOINT = {
  GET_CENTRES_BY_SCHOOL_IDS: '/get-centres-by-school-ids',
  GET_CENTRE_DOCUMENTS:
    '/centre-document/list-all-centre-document-by-categories',
};

export const TERM_CENTRES_ENDPOINT = {
  TERM_CENTRES: '/get-term-centres',
};

export const REPORT_SVC_ENDPOINT = {
  GET_REPORTS: '/',
  GET_DOCUMENTS: '/documents',
  GENERATE_REPORT: '/generate',
};

export const MS_PHASE_2B_CLASS_ACTIVITY_ENPOINT = {
  PORTFOLIO: {
    DELETE: id => `/portfolio/${id}`,
    SAVE_CHILD_PORTFOLIO: '/portfolio/save-child-portfolio',
    UPDATE_PORTFOLIO_STATUS: '/portfolio/update-child-portfolio-status',
    GET_PORTFOLIO_PHOTO_UPLOAD_URL: '/portfolio/get-portfolio-photo-upload-url',
    GET_CHILD_AREA_OF_INTEREST_AND_RECOMMENDATION:
      '/portfolio/get-child-area-of-interest-and-recommendation',
    GET_MY_DOWNLOAD_PORTFOLIO: '/portfolio/get-my-download-portfolio',
    GET_PORTFOLIO_TERM_BY_YEAR: '/portfolio/get-term-by-year',
    GET_CHILD_PORTFOLIO: '/portfolio/get-child-portfolio',
    GET_PORTFOLIO_BY_ID: id => `/portfolio/${id}`,
    GET_PORTFOLIO_CLASS_TEACHERS: (portfolioIds = [], params = {}) => [
      `/portfolio/get-portfolio-class-teachers-by-portfolio-ids?${new URLSearchParams(
        {
          page: 1,
          ...params,
        }
      )}`,
      {
        portfolio_ids: portfolioIds,
      },
    ],
    GET_TERM_BY_IDS: (termIds = [], params = {}) => [
      `/portfolio/get-terms-by-ids?${new URLSearchParams({
        page: 1,
        perPage: termIds.length,
        ...params,
      })}`,
      {
        term_ids: termIds,
      },
    ],
    GET_PORTFOLIO_CHILD_LEARNING_GOAL_EVALUATIONS:
      '/portfolio/get-portfolio-child-learning-goal-evaluations',
    GET_PORTFOLIO_CLASS_ACTIVITIES: '/portfolio/get-portfolio-class-activities',
    GET_PORTFOLIO_CLASS_ACTIVITY_BY_ID: portfolioId =>
      `/portfolio/portfolio-class-activity/${portfolioId}`,
    GET_DOMAINS_BY_DOMAIN_IDS: (domainIds = [], params = {}) => [
      `/portfolio/get-domain-by-domain-ids?${new URLSearchParams({
        page: 1,
        perPage: domainIds?.length,
        ...params,
      })}`,
      {
        domain_ids: domainIds,
      },
    ],
    BULK_PUBLISH_PORTFOLIOS: (portfolioIds = []) => [
      '/portfolio/change-bulk-portfolios-status-to-published',
      {
        portfolio_ids: portfolioIds,
      },
    ],
    GET_LIST_DOMAIN: '/domain/get-list-domain',
    GET_PORTFOLIO_UPLOAD_URL: '/portfolio/get-portfolio-pdf-upload-url',
    SAVE_CHILD_EVALUATION:
      '/portfolio/insert-or-update-child-learning-goal-evaluation',
  },
  CHECKLIST: {
    SAVE_SEMESTER_CHECKLIST_EVALUATION: '/checklist/save-semester-evaluation',
    SAVE_MULTI_LITERACY_CHECKLIST_EVALUATION:
      '/checklist/save-multi-literacy-evaluation',
    SAVE_LANGUAGE_FUNCTION_CHECKLIST_EVALUATION:
      '/checklist/save-language-function-evaluation',
    SAVE_LITERACY_TS1_CHECKLIST_EVALUATION:
      '/checklist/save-child-literacy-transaction-one-evaluation',
    SAVE_LITERACY_TS2_CHECKLIST_EVALUATION:
      '/checklist/save-child-literacy-transaction-two-evaluation',
    SAVE_READING_BEHAVIOR_CHECKLIST_EVALUATION:
      '/checklist/save-reading-behavior-evaluation',
    SAVE_HIGH_FREQUENCY_CHECKLIST_EVALUATION:
      '/checklist/save-high-frequency-evaluation',
    SAVE_LETTER_IDENTIFICATION_CHECKLIST_EVALUATION:
      '/checklist/save-letter-identification-evaluation',
    GET_SEMESTER_CHECKLIST: '/checklist/get-semester-checklist',
    GET_HIGH_FREQUENCY_CHECKLIST: '/checklist/get-high-frequency-checklist',
    GET_CHILD_CHECKLIST: '/checklist/get-child-checklist',
    GET_LIST_DOMAINS_BY_LEVEL: '/domain/get-list-domain-by-level',
    GET_EVALUATION_LABELS: levelId =>
      `/checklist/get-evaluation-labels/${levelId}`,
    GET_LITERACY_TRACKING_SECTION_ONE:
      '/checklist/get-child-literacy-tracking-section-one',
    GET_LITERACY_TRACKING_SECTION_TWO:
      '/checklist/get-child-literacy-tracking-section-two',
    GET_CHILD_LITERACY_TRACKING_SECTION_TWO_OPTIONS: (
      fkLiteracyTrackingSectionTwos = [],
      params = {}
    ) => [
      `/checklist/get-child-literacy-tracking-section-two-input-options?${new URLSearchParams(
        params
      )}`,
      { literacy_tracking_section_two_ids: fkLiteracyTrackingSectionTwos },
    ],
    GET_LETTER_IDENTIFICATION: '/checklist/get-letter-identification-checklist',
    GET_READING_BEHAVIOR_CHECKLIST: '/checklist/get-reading-behavior-checklist',
    GET_CHILD_SEMESTER_EVALUATION: '/checklist/get-child-semester-evaluation',
    GET_MIGRATED_CHECKLIST_CLASS:
      '/checklist/get-migrated-checklist-class-by-centre',
  },
  CLASS_ACTIVITY: {
    REJECT_MS_CLASS_ACTIVITY: id =>
      `/class-activity/reject-class-activity/${id}`,
    GET_MY_DOWNLOAD_ALBUM: '/class-activity/get-my-download-album',
    FIND_CLASS_ACTIVITY: '/class-activity/find-class-activities',
    GET_CLASS_ACTIVITY_IMAGES: (classActivityIds = [], params = {}) => [
      `/class-activity/get-class-activity-images-by-class-activity-ids?${new URLSearchParams(
        {
          ...params,
        }
      )}`,
      {
        class_activity_ids: classActivityIds,
      },
    ],
    BULK_PUBLISH_RECORD_OF_LEARNING_AND_DEVELOPMENT:
      '/class-activity/bulk-publish-record-of-learning-and-development',
    SEARCH_CLASS_ACTIVITY_TAG: '/class-activity/search-class-activity-tag',
    DELETE_CLASS_ACTIVITYIES: '/class-activity/delete-class-activities',
    CREATE_OR_UPDATE_CLASS_ACTIVITY: '/class-activity',
    PUBLISH_CLASS_ACTIVITY: id =>
      `/class-activity/publish-class-activity/${id}`,
    UPDATE_CLASS_ACTIVITY_STATUS:
      '/class-activity/update-class-activity-status',
    CLASS_ACTIVITY_MEDIA: '/class-activity/class-activity-media',
    GET_CLASS_ACTIVITY_TAGS:
      '/class-activity/class-activity-tag-relation/get-by-class-activity-ids',
    GET_CLASS_ACTIVITY_LOGS: '/class-activity/logs/get-by-class-activity-ids',
    GET_CLASS_ACTIVITY_PARENT_INTERACTIONS:
      '/class-activity/parent-interactions/get-by-class-activity-ids',
    GET_CLASS_ACTIVITY_LEARNING_GOALS:
      '/class-activity/learning-goal/get-by-class-activity-ids',
    GET_CLASS_ACTIVITY_CLASSES:
      '/class-activity/class/get-by-class-activity-ids',
    GET_CLASS_ACTIVITY_CHILDRENS:
      '/class-activity/child/get-by-class-activity-ids',
    GET_CLASS_ACTIVITY_DEVELOPMENT_LEARNING_AREAS:
      '/class-activity/development-learning-areas/get-by-class-activity-ids',
    GET_CLASS_ACTIVITY_LESSON_PLANS:
      '/class-activity/lesson-plan/get-by-class-activity-ids',
    FIND_OBSERVATION_DASHBOARD_V2:
      '/class-activity/find-observation-dashboard-v2',
    FIND_OBSERVATION_DASHBOARD_MIGRATED_V2:
      '/class-activity/find-observation-dashboard-migrated-v2',
    CLASS_ACTIVITY_IMAGE_MIGRATED: (classActivityIds = [], params = {}) => [
      `/class-activity/class-activity-image-migrated/get-by-image-migrated-ids?${new URLSearchParams(
        {
          ...params,
        }
      )}`,
      {
        class_activity_migrated_ids: classActivityIds,
      },
    ],
    GET_CLASS_ACTIVITY_USER_STAFF: (classActivityIds = [], params = {}) => [
      `/class-activity/get-user-staff-by-class-activity-ids?${new URLSearchParams(
        {
          page: 1,
          perPage: classActivityIds.length,
          ...params,
        }
      )}`,
      {
        class_activity_ids: classActivityIds,
      },
    ],
    GET_LESSON_PLANS: '/class-activity/lesson-plan/get-lesson-plan',
    GET_LESSON_PLAN_BY_ID: '/lesson-plan-learning-goal/get-by-lesson-plan-ids',
    CREATE_CLASS_ACTIVITY_TAG: '/class-activity/class-activity-tag',
  },
  USER: {
    GET_BY_IDS: (userIds = []) => [
      `/get-by-ids?${new URLSearchParams({
        page: 1,
        perPage: userIds.length,
        status: ALL_USERS,
      })}`,
      {
        userIds,
      },
    ],
    // staff
    GET_STAFF_USER_BY_USER_IDS: userIds => [
      `staff/staff-user-by-user-ids?${new URLSearchParams({
        page: 1,
        perPage: userIds.length,
      })}`,
      { user_ids: userIds },
    ],
    getAddressByReqParentIds: (reqParentIds = []) => [
      `/address/get-by-registration-parent-ids`,
      { parent_ids: reqParentIds },
    ],
    GET_PARENT_BY_ID: parentId => `/parent/${parentId}`,
    GET_ADDRESS_BY_CENTRE_ID: centreId =>
      `/address/get-by-centre-id/${centreId}`,
    GET_PARENT_BY_IDS: (parentIds = []) => [
      `/parent/get-parent-by-ids?${new URLSearchParams({
        page: 1,
        perPage: parentIds.length,
      })}`,
      {
        parent_ids: parentIds,
      },
    ],
  },
  CLASS: {
    GET_CLASS_BY_IDS: (classIds = []) => [
      `/get-by-ids?${new URLSearchParams({
        page: 1,
        perPage: classIds.length,
      })}`,
      {
        classIds,
      },
    ],
    GET_CLASS_LEVEL_BY_CLASS_IDS: (classIds = []) => [
      `/class-level/get-class-level-by-class-ids`,
      {
        class_ids: classIds,
      },
    ],
    GET_CLASS_TEACHERS_BY_CLASS_IDS: (classIds = [], params = {}) => [
      `/class-teacher/get-by-class-ids?${new URLSearchParams({
        page: 1,
        ...params,
      })}`,
      { class_ids: classIds },
    ],
    GET_LEARNING_GOALS_BY_CLASS: '/learning-goal/get-learning-goals-by-class',
    GET_LEARNING_GOALS_BY_IDS: (ids = [], params = {}) => [
      `/class-activity/learning-goal/get-by-ids?${new URLSearchParams({
        page: 1,
        perPage: ids?.length,
        ...params,
      })}`,
      {
        learning_goal_ids: ids,
      },
    ],
    GET_LEARNING_GOALS_BY_DOMAIN_IDS: (ids = [], params = {}) => [
      `/learning-goal/get-by-domain-ids?${new URLSearchParams({
        page: 1,
        perPage: ids?.length,
        ...params,
      })}`,
      {
        domain_ids: ids,
      },
    ],
    GET_BY_CENTRE_IDS: (centreIds = [], params = {}) => [
      `/get-by-centres?${new URLSearchParams({
        page: 1,
        perPage: centreIds?.length,
        ...params,
      })}`,
      {
        centreIds,
      },
    ],
    GET_TEACHER_CLASS_LEVELS: teacherId =>
      `/class-teacher/get-class-and-level-by-teacher-id/${teacherId}`,
  },
  SCHOOL: {
    GET_LEVEL_BY_IDS: (levelIds = []) => [
      `/level/get-by-ids?${new URLSearchParams({
        page: 1,
        perPage: levelIds.length,
      })}`,
      { level_ids: levelIds },
    ],
    GET_CODE_BY_ID: id => `/code/${id}`,
  },
  CHILD: {
    GET_CHILD_BY_IDS: (childIds = []) => [
      `/get-by-ids?${new URLSearchParams({
        page: 1,
        perPage: childIds.length,
      })}`,
      { childIds },
    ],
    SAVE_HEALTH_DETAILS_FROM_FILE: (body = {}) => [
      '/child-health/save-health-details-from-file',
      body,
    ],
    SEARCH_CHILD_NOT_ASSINED_TO_BUS: (query, centreId) =>
      `/search/child-not-assigned-to-bus?${new URLSearchParams({
        q: query,
        centreId,
      })}`,
    GET_CHILD_CURRENT_CLASS_BY_IDS: (childIds = []) => [
      `/child-class/get-child-current-class-by-child-ids?${new URLSearchParams({
        page: 1,
        perPage: childIds.length,
      })}`,
      { child_ids: childIds },
    ],
    GET_LEVEL_BY_CHILD_IDS: (childIds = []) => [
      '/child-level/get-level-by-child-ids',
      {
        childIds,
      },
    ],
    GET_CLOSED_LEVEL_BY_CHILD_IDS: (childIds = [], params = {}) => [
      `/child-level/get-closest-level-by-child-ids?${new URLSearchParams({
        page: 1,
        ...params,
      })}`,
      {
        child_ids: childIds,
      },
    ],
    GET_CHILD_CLASSES_BY_CHILD_IDS: (
      childIds = [],
      params = {},
      filter = {}
    ) => [
      `/child-class/get-all-by-child-ids?${new URLSearchParams({
        ...params,
      })}`,
      {
        child_ids: childIds,
        child_class_filter: filter,
      },
    ],
    GET_CHILD_CLASSES_AT_BY_CHILD_IDS: (childIds = [], at = '') => [
      `/child-class/get-child-class-at-by-child-ids?${new URLSearchParams({
        page: 1,
      })}`,
      {
        child_ids: childIds,
        at,
      },
    ],
    GET_DOCUMENT_TYPES_BY_BANK_ACCOUNT_IDS: bankAccountIds => [
      '/document-type/by-bank-account',
      {
        bank_account_ids: bankAccountIds,
      },
    ],
    GET_CHILD_RELATIONS_BY_ID: childId =>
      `/child-relation/get-child-relation-by-child/${childId}`,
    GET_SIBLINGS_BY_CHILDBC_AND_PARENT_ID: (childBC, parentId) =>
      `siblings?child-bc=${childBC}&parent-id=${parentId}`,
    GET_APPLICANT_OF_CHILD: childId =>
      `/child-relation/get-applicant-of-child/${childId}`,
  },
  CENTRE: {
    GET_CENTRE_BY_IDS: (centreIds = []) => [
      `/get-by-ids?${new URLSearchParams({
        page: 1,
        perPage: centreIds.length,
      })}`,
      { centreIds },
    ],
    GET_PROGRAMS_BY_IDS: (programIds = [], params = {}) => [
      `/program/get-by-ids?${new URLSearchParams({
        page: 1,
        perPage: programIds?.length,
        ...params,
      })}`,
      { program_ids: programIds },
    ],
    GET_CHILD_HISTORICAL_CENTRE: '/get-child-historical-centre',
    GET_CHILD_HISTORICAL_CENTRE_CLASS: (childId, centreId) => [
      `/get-child-historical-centre-class`,
      {
        child_id: childId,
        ...(centreId && { centre_id: centreId }),
      },
    ],
  },
};

export const MS_PHASE_2D_CLASS_OPERATIONS_ENDPOINTS = {
  EVENT: {
    GET_EVENTS: '/events/',
    GET_EVENT_TYPES: '/events/types',
    GET_EVENT_BY_ID: eventId => `/events/${eventId}`,
    CREATE_EVENT: '/events',
    GET_EVENT_PHOTO_ALBLUM_UPLOAD_URL: eventId =>
      `/events/${eventId}/photo-upload-url`,
    GET_EVENT_UPLOAD_URL_FOR_SCHOOL: 'events/image-upload-url',
    CANCEL_EVENT: eventId => `events/${eventId}/cancel`,
    CREATE_DRAFT_EVENT: '/draft-events',
    GET_DRAFT_EVENTS: '/draft-events',
    SUBMIT_DRAFT_EVENT: eventId => `/draft-events/${eventId}/submit`,
    GET_DRAFT_EVENT_BY_ID: eventId => `/draft-events/${eventId}`,
    UPDATE_EVENT: eventId => `/events/${eventId}`,
    UPDATE_DRAFT_EVENT: eventId => `/draft-events/${eventId}`,
    DELETE_DRAFT_EVENT: eventId => `/draft-events/${eventId}`,
    PUBLISH_EVENT: eventId => `/events/${eventId}/publish`,
    // rsvp
    GET_EVENT_RSVPS: eventId => `/events/${eventId}/rsvps`,
    EXPORT_RSVP_LIST: eventId => `/events/${eventId}/export`,
    GET_RSVP_COUNT_DETAILS_BY_IDS: 'events/rsvp-count-details',
    REMOVE_CHILD_FROM_RSVP_LIST: (eventId, rsvpId) =>
      `/events/${eventId}/rsvps/${rsvpId}`,
    REMOVE_RSVP_GUESTS: (eventId, rsvpId, guestIds = []) =>
      `/events/${eventId}/rsvps/${rsvpId}/guests?${new URLSearchParams({
        guestIds: guestIds.join(','),
      })}`,
    ADD_EVENT_RSVP: eventId => `/events/${eventId}/rsvps`,
    // photos
    GET_EVENT_PHOTOS: eventId => `events/${eventId}/photos`,
    ADD_EVENT_PHOTOS: eventId => `events/${eventId}/photos`,
    UPDATE_EVENT_PHOTOS_INDEX: eventId => `events/${eventId}/photos-index`,
    DELETE_EVENT_PHOTOS: eventId => `events/${eventId}/photos`,
    // scope
    GET_EVENT_SCOPES_BY_IDS: 'events/scopes',
    // dashboard
    GET_PENDING_EVENT_GROUPED_BY_CENTER:
      '/events/pending-events-grouped-by-center',
    // calendar
    GET_CALENDAR_EVENTS: '/events/calendar',
  },
  VISITOR: {
    GET_VISITOR_LOGS: '/visitor/log',
    CODE: id => `/code/${id}`,
  },
  BUS: {
    LIST_ALL_BUS_ENTRIES: `/bus-entry/list`,
    DELETE_BUS_ENTRY: id => `/bus-entry/${id}`,
    BUS_ROUTE: `/bus-route/`,
    LIST_ALL_BUS_CHILDREN: `/bus-child/list-all-bus-children`,
    GET_BUS_BY_IDS: `bus/get-bus-by-ids`,
    CREATE_BUS_CHILD: `/bus-child/`,
    DELETE_CHID_FROM_BUS: id => `/bus-child/${id}/`,
    GET_BUS_USER_BY_IDS: `/bus-user/get-bus-user-by-ids`,
  },
  RESOURCES: {
    GET_CLASS_SECTIONS: `/class-resource/sections/`,
    CREATE_CLASS_SECTION: `/class-resource/sections/`,
    UPDATE_CLASS_SECTION: sectionId => `/class-resource/sections/${sectionId}`,
    DELETE_CLASS_SECTION: sectionId => `/class-resource/sections/${sectionId}`,
    RE_ARRANGE_CLASS_SECTIONS: `/class-resource/sections/rearrange`,
    GET_CLASS_RESOURCES: `/class-resource/resources/`,
    RE_ARRANGE_CLASS_SECTION_RESOURCES: `/class-resource/resources/rearrange`,
    CREATE_CLASS_RESOURCE: `/class-resource/resources/`,
    UPDATE_CLASS_RESOURCE: sectionId =>
      `/class-resource/resources/${sectionId}`,
    GET_CLASS_RESOURCE_UPLOAD_URL: resourceId =>
      `/class-resource/resources/${resourceId}/file-upload-url`,
    DELETE_CLASS_RESOURCE: resourceId =>
      `/class-resource/resources/${resourceId}`,
    GET_CLASS_SECTIONS_AND_RESOURCES: `/class-resource/sections-and-resources`,
  },
};

export const MS_PHASE_3_ENDPOINTS = {
  LINKPASS: {
    loginByLinkpass: (body = {}) => [
      '/linkpass/login-by-linkpass',
      { ...body },
    ],
    registerWithLinkpass: (body = {}) => [
      '/linkpass/register-with-linkpass',
      { ...body },
    ],
    linkUserWithLinkpass: (body = {}) => [
      '/linkpass/link-user-with-linkpass',
      { ...body },
    ],
  },
  ONBOARDING: {
    syncChildParentDataToHubspot: (body = {}) => [
      '/onboarding/v1/hubspot/sync-child-parent-data-to-hubspot',
      body,
    ],
  },
  REGISTRATIONS: {
    getExistingChild: 'registration-child/get-existing-child',
    getRegistrationChildParents: id =>
      `/registration-child-parent/get-by-registration-child-id/${id}`,
    getEcdaRegistraionChildParentsByEcdaRegistrationParentIds: id =>
      `/ecda-registration-child-parent/get-by-ecda-registration-parent-ids?ecdaRegistrationParentIDs=${id}`,
    getEcdaRegistrationChildByIds: (ids = []) => [
      '/ecda-registration-child/get-by-ids',
      { ecda_registration_child_ids: ids },
      { params: { page: 1, perPage: ids?.length } },
    ],
    getEcdaRegistrationChildById: id => `/ecda-registration-child/${id}`,
    getSiblingsByChildId: id =>
      `/registration/ecda-registration-parent/get-siblings/${id}`,
    getRegistrationChildByIds: (ids = []) => [
      '/registration-child/get-by-ids',
      { registration_child_ids: ids },
      { params: { page: 1, perPage: ids?.length } },
    ],
    getRegistrationChildMappingByRegistrationChildIds: (
      ids = [],
      params = {}
    ) => [
      '/registration-child-mapping/get-by-registration-child-ids',
      { registration_child_ids: ids },
      { params: { page: 1, perPage: ids?.length, ...params } },
    ],
    findAllRegistrationChild: ({ filter = {}, params = {} }) => [
      '/registration-child/find-all-registration-child',
      { filter },
      { params },
    ],
    getAllReqChildMappings: ({ params = {}, ...body }) => [
      '/registration-child-mapping/find-all-registration-child-mapping',
      { ...body },
      { params },
    ],
    getRegistrationByID: id => `registration/${id}`,
    getRegistrationChildMappingByRegId: id =>
      `/registration-child-mapping/get-by-registration-id/${id}`,
    getRegistrationChildById: regId => `/registration-child/${regId}`,
    getReqParentsByIds: (reqParentIds = []) => [
      '/registration-parent/get-by-ids',
      {
        registration_parent_ids: reqParentIds,
      },
    ],
    getECDARegistrations: (reqBody = {}, params = {}) => [
      '/registration/ecda-registration/get-ecda-registrations',
      { ...reqBody },
      { params },
    ],
    getEcdaRegistrationParentByIds: (ids = []) => [
      '/registration/ecda-registration-parent/get-by-ids',
      { ecda_registration_parent_ids: ids },
      { params: { page: 1, perPage: ids?.length } },
    ],
    getECDAExistingParent: (reqBody = {}) => [
      '/registration/ecda-registration-parent/get-ecda-existing-parent',
      { ...reqBody },
    ],
    suggestLevels: (reqBody = {}) => [
      '/registration-query/suggest-levels',
      { ...reqBody },
    ],
    suggestLevel: (reqBody = {}) => [
      '/registration-query/suggest-level',
      { ...reqBody },
    ],
    getECDARegChildParentByECDARegParentIds: (ecdaRegParentIds = []) => [
      '/ecda-registration-child-parent/get-by-ecda-registration-parent-ids',
      { ecdaRegistrationParentIDs: ecdaRegParentIds.join(',') },
      { params: { page: 1, perPage: ecdaRegParentIds?.length } },
    ],
    getECDAExistingChild: (reqBody = {}) => [
      '/registration/ecda-registration/get-ecda-existing-child',
      { ...reqBody },
    ],
    getECDARegistrationChildParentsById: ecdaRegistrationChildID =>
      `/ecda-registration-child-parent/get-by-ecda-registration-child-id/${ecdaRegistrationChildID}`,
    getRegParentChangesByRegChildId: regChildId =>
      `/registration-parent/get-registration-parent-changes-by-child-id/${regChildId}`,
    getRegFrontendStates: () =>
      `/registration/get-registration-frontend-states`,
    getRegistrationsByLeadIds: (leadIds = []) => [
      `/registration/get-by-lead-ids`,
      { leadIDs: leadIds?.join(',') },
    ],
    getRegistrations: (body = {}, params = {}) => [
      '/registration/get-registrations',
      body,
      { params },
    ],
    getRegChildMappingByRegIds: (regIds = []) => [
      '/registration-child-mapping/get-by-registration-ids',
      { registration_ids: regIds },
      { params: { page: 1, perPage: regIds?.length } },
    ],
    getRegParentsByRegChildIds: (regChildIds = []) => [
      '/registration-parent/get-by-registration-child-ids',
      {
        registrationChildIDs: regChildIds?.join(','),
        page: 1,
        perPage: regChildIds?.length,
      },
    ],
    ecdaRegistrationGetUserById: id =>
      `/registration/ecda-registration-parent/get-by-user-id/${id}`,
    getECDARegistrationTCUploadUrl:
      '/registration/ecda-registration/get-ecda-registration-tc-upload-url',
    getRegistrationDocumentUploadUrl:
      'registration/get-registration-document-upload-url',
    getRegistrationConsentUploadURL:
      '/registration/get-registration-consent-upload-url',
    requireConfirmationForSpouse: (body = {}) => [
      '/registration-parent/require-confirmation-for-spouse',
      body,
    ],
    getFormSigners: registrationId =>
      `/registration-consent/${registrationId}/form-signers`,
    sendConsentForm: registrationConsentId =>
      `/registration-consent/${registrationConsentId}/send-form`,
    requireConfirmationForECDASpouse: (body = {}) => [
      '/registration/ecda-registration-parent/require-confirmation-for-ecda-spouse',
      body,
    ],
    getFamilyMembersByRegChildId: regChildID =>
      `/registration-child/get-family-members-by-child/${regChildID}`,
    getExistingParent: '/registration-parent/get-existing-parent',
    submitRegistrationForm: registrationID =>
      `registration-form/submit/${registrationID}`,
    editRegistration: 'registration/edit',
    getRegChildByRegistrationId: registrationId =>
      `registration-child/get-by-registration-id/${registrationId}`,
    cancelRegistration: 'registration/cancel',
    reinstateCancelledRegistration: '/registration/reinstate-cancelled',
    getInvoiceByRegId: '/registration-payment/invoice-by-registration',
    getRegParentByUserIds: (userIds = []) => [
      '/registration-parent/get-by-user-ids',
      { userIds },
      { params: { page: 1, perPage: userIds?.length } },
    ],
    saveRegAdditionalInfo: '/registration-additional-info/save',
    getRegAdditionalInfo: registrationId =>
      `registration-additional-info/${registrationId}`,
    createRegistration: 'registration/create',
    getRegChildParentsByParentIds: (parentIDs = [], params = {}) => [
      `/registration-child-parent/get-by-registration-parent-ids?${new URLSearchParams(
        {
          parentIDs: parentIDs?.join(','),
          ...params,
        }
      ).toString()}`,
    ],
    getMarketingConsentBusinessEntityByParent:
      '/marketing-consent/mc-business-entity/by-parent-id',
    getMarketingConsentDocumentUploadURL:
      '/marketing-consent/document/get-upload-url',
    upsertRegLorDetail: (body = {}) => [
      '/registration/ecda-registration/upsert-reg-lor-detail',
      body,
    ],
    clearRegLorDetail: (params = {}) =>
      `/registration/ecda-registration/clear-reg-lor-detail?${new URLSearchParams(
        params
      )}`,
    skipGiroForRegistration: registrationID =>
      `/registration/skip-giro-for-registration/${registrationID}`,
    updateMarketingConsentDashboard: '/marketing-consent/dashboard',
    getRegEnrolmentForm: registrationID =>
      `/registration-form/enrolment-form/${registrationID}`,
    saveRegEnrolmentForm: '/registration-form/enrolment-form/save',
    getFamilyMembersByRegChildIds:
      '/registration-child/get-family-members-by-registration-child-ids',
    cancelForm: regId => `/registration-consent/${regId}/cancel-form`,
    saveRegistrationConsentOfflineForm: regID =>
      `/registration-consent/${regID}/save-offline-form`,
    markConsentCompleted: registrationId =>
      `/registration-consent/${registrationId}/mark-consent-completed`,
  },
  ECDA_REGISTRATIONS: {
    getECDARegEnrolmentForm: id =>
      `/ecda-registration-form/ecda-reg-enrolment-form/${id}`,
    createNewEcdaRegistration: (body = {}) => [
      '/registration/ecda-registration/create-new-ecda-registration',
      body,
    ],
    ecdaRegistrationByID: id => `/registration/ecda-registration/${id}`,
    editRegistrationECDAMVP: (body = {}) => [
      '/registration/ecda-registration/edit-ecda-registration',
      body,
    ],
    removeECDARegistrationDocument: (reqBody = {}) => [
      `/ecda-registration-document/remove`,
      { ...reqBody },
    ],
    getECDARegParentAttributesByECDARegParentIds: (ecdaRegParentIds = []) => [
      '/registration/ecda-registration-parent/get-ecda-reg-parent-att-by-ecda-reg-parent-ids',
      { ecda_registration_parent_ids: ecdaRegParentIds },
    ],
    getECDARegistrationDocumentUploadUrl: (body = {}) => [
      '/registration/ecda-registration/get-ecda-registration-document-upload-url',
      { ...body },
    ],
    saveECDARegEnrolmentForm: '/ecda-registration-form/save',
    submitECDARegistrationForm: (body = {}) => [
      '/ecda-registration-form/submit',
      body,
    ],
    getAllECDARegistrationChild:
      '/ecda-registration-child/find-all-ecda-registration-child',
    getLifeSgExceptionSelection: (schoolId, ecdaRegId) => [
      `/registration/ecda-registration/get-life-sg-exception-selection?schoolID=${schoolId}&ecdaRegID=${ecdaRegId}`,
    ],
    getRegistrationDraftFeeInvoice: (params = {}) =>
      `/ecda-registration-payment/fee-invoice-by-registration?${new URLSearchParams(
        params
      )}`,
    getECDACdaAccountStatementUploadURL: (body = {}) => [
      '/ecda-registration-document/get-ecda-cda-account-statement-upload-url',
      body,
    ],
    getEcdaSiblingBirthCertificateUploadURL: (body = {}) => [
      '/ecda-registration-document/get-ecda-sibling-birth-certificate-upload-url',
      body,
    ],
    cancelEcdaRegistration: (body = {}) => [
      '/registration/ecda-registration/cancel-ecda-registration',
      body,
    ],
    reinstateEcdaRegistration:
      '/registration/ecda-registration/reinstate-cancelled-ecda-registration',
    getByRegChildIds: (ecdaRegChildIds = []) => [
      `/registration/ecda-registration/get-by-registration-child-ids`,
      {
        ids: ecdaRegChildIds.join(','),
      },
    ],
    getRegLorDetail: (params = {}) =>
      `/registration/ecda-registration/get-reg-lor-detail?${new URLSearchParams(
        params
      )}`,
    markGiroAsCompleted: ecdaRegistrationID =>
      `/registration-giro/mark-completed-for-ecda/${ecdaRegistrationID}`,
    startEcdaRegistration: ecdaRegistrationID =>
      `/registration/ecda-registration/start-ecda-registration/${ecdaRegistrationID}`,
  },
  FINANCE: {
    getInvoices: '/invoice/find-all-invoice',
    getAllCreditDebitNotes: '/credit-debit-note/find-all',
    getCreditDebitNoteItems: (ids = []) => [
      '/credit-debit-note-item/by-credit-debit-note-ids',
      {
        credit_debit_note_ids: ids,
      },
    ],
    getInvoicesByIds: (invoiceIds = []) => [
      '/invoice/invoices/by-ids',
      {
        invoice_ids: invoiceIds,
      },
    ],
    getChildBalanceSheet: ({ centreId, childId }, params = {}) => [
      `/child-balance-sheet/get-child-balance-sheet`,
      {
        centre_id: centreId,
        child_id: childId,
      },
      { params },
    ],
    getRegistrationChildBalanceSheet: ({ centreId, childId }, params = {}) => [
      '/child-balance-sheet/get-registration-child-balance-sheet',
      {
        centre_id: centreId,
        registration_child_id: childId,
      },
      { params },
    ],
    getEcdaRegistrationChildBalanceSheet: ({
      IDCentre,
      ecdaRegistrationChildId,
    }) => [
      '/child-balance-sheet/get-ecda-registration-child-balance-sheet',
      {
        centre_id: IDCentre,
        ecda_registration_child_id: ecdaRegistrationChildId,
      },
    ],
    updateChildTradeDebtNotification: ({ childID, notificationEnabled }) => [
      '/trade-debt/update-child-trade-debt-notification',
      {
        child_id: childID,
        notification_enabled: notificationEnabled,
      },
    ],
    getTradeDebtNotifications: id => `/trade-debt/notifications/${id}`,
    getAllChildDiscounts: ({ childID }) => [
      '/discount/get-all-child-discounts',
      {
        child_id: childID,
      },
    ],
    getAllRegistrationChildDiscounts: ({ childID, filter }) => [
      '/discount/get-all-reg-child-discounts',
      {
        child_id: childID,
        filter,
      },
    ],
    getAllEcdaRegistrationChildDiscounts: ({ childID, pagination = {} }) => [
      '/discount/get-all-ecda-reg-child-discounts',
      {
        child_id: childID,
      },
      { params: pagination },
    ],
    getDiscountItemsByIds: (ids = []) => [
      '/discount/item/get-by-ids',
      {
        ids,
      },
    ],
    addDiscountGroup: (reqData = {}) => [
      '/discount-item-group/add',
      { ...reqData },
    ],
    addEcdaRegistrationChildDiscount: (params = {}) => [
      '/discount/add-ecda-registration-child-discount',
      { ...params },
    ],
    addRegistrationChildDiscount: (params = {}) => [
      '/discount/add-registration-child-discount',
      { ...params },
    ],
    addChildDiscount: (params = {}) => [
      '/discount/add-child-discount',
      { ...params },
    ],
    removeChildDiscount: (params = {}) => [
      '/discount/remove-child-discount',
      { ...params },
    ],
    removeRegistrationChildDiscount: (params = {}) => [
      '/discount/remove-reg-child-discount',
      { ...params },
    ],
    removeEcdaRegistrationChildDiscount: (params = {}) => [
      '/discount/remove-ecda-reg-child-discount',
      { ...params },
    ],
    deactivateChildDiscount: (params = {}) => [
      '/discount/deactivate-child-discount',
      { ...params },
    ],
    deactivateRegistrationChildDiscount: (params = {}) => [
      '/discount/deactivate-reg-child-discount',
      { ...params },
    ],
    deactivateEcdaRegistrationChildDiscount: (params = {}) => [
      '/discount/deactivate-ecda-reg-child-discount',
      { ...params },
    ],
    getBankAccountByFkEcdaRegistrationChild: ecdaRegistrationChildId => [
      '/bank-account/get-by-ecda-registered-child-id',
      { ecda_reg_child_id: ecdaRegistrationChildId },
    ],
    getBankAccountByFkRegistrationChild: registrationChildId => [
      `/edda-aggregator/account-details-by-registration-child/${registrationChildId}`,
    ],
    writeOffCreditBalance: (reqParams = {}) => [
      '/credit-write-off/write-off-credit-balance',
      { ...reqParams },
    ],
    getDebtWriteOffDocUploadURL: (reqParams = {}) => [
      '/credit-debit-note/upload-url/get-debt-write-off-supporting-document-upload-url',
      { ...reqParams },
    ],
    writeOffInvoices: (reqParams = {}) => [
      '/credit-debit-note/write-off-invoices',
      { ...reqParams },
    ],
    getCreditWriteOffSupportingDocumentUploadURL:
      '/credit-debit-note/upload-url/get-credit-write-off-supporting-document-upload-url',
    createReceiptForOfflinePayment: (reqParams = {}) => [
      '/receipt/create-receipt-for-offline-payment',
      { ...reqParams },
    ],
    getFeeTierByRegistrationId: id =>
      `/fee/get-fee-tier-by-registration-id/${id}`,
    getFeeForChild: (body = {}) => [
      '/fee/get-fee-tier-for-registration-child',
      body,
    ],
    cancelReceipt: (body = {}) => ['/receipt/cancel-receipt', { ...body }],
    unlinkReceipt: (body = {}) => ['/receipt/unlink-receipt', { ...body }],
    getEcdaRegistrationRefundChildBalance: (body = {}, params = {}) => [
      '/refund/ecda-registration-child-balance',
      { ...body },
      { params },
    ],
    listBulkInvoices: (body = {}, params = {}) => [
      '/bulk-invoice/list-bulk-invoice',
      {
        ...body,
      },
      { params },
    ],
    updateRefundStatus: ({
      cancellationReason,
      newStatus,
      refundChildBalanceID,
    } = {}) => [
      '/refund/status',
      {
        cancellation_reason: cancellationReason,
        new_status: newStatus,
        refund_child_balance_id: refundChildBalanceID,
      },
    ],
    getAdvancePaymentReceiptsForEcdaRegistration: (
      reqBody = {},
      params = {}
    ) => [
      '/receipt/get-advance-payment-receipts-for-ecda-registration',
      { ...reqBody },
      { params },
    ],
    getAdvancePaymentReceipts: (body = {}, params = {}) => [
      '/receipt/get-advance-payment-receipts',
      { ...body },
      { params },
    ],
    getAdvancePaymentReceiptsForRegistration: (body = {}, params = {}) => [
      '/receipt/get-advance-payment-receipts-for-registration',
      { ...body },
      { params },
    ],
    adjustInvoiceAmountByInvoiceItemsPreview: (body = {}) => [
      '/invoice/adjust-amount-by-items-preview',
      { ...body },
    ],
    adjustAmountByItems: (body = {}) => [
      '/invoice/adjust-amount-by-items',
      { ...body },
    ],
    getRefundChildBalance: (body = {}, params = {}) => [
      '/refund/child-balance',
      { ...body },
      { params },
    ],
    getAllRefundChildBalance: (reqBody = {}, params = {}) => [
      `/refund/all-child-balance`,
      { ...reqBody },
      { params },
    ],
    getAllChildBalanceECDA: (reqBody = {}, params = {}) => [
      `/refund/all-child-balance-ecda`,
      { ...reqBody },
      { params },
    ],
    createAdvancePaymentReceipt: (body = {}) => [
      '/receipt/create-advance-payment-receipt',
      body,
    ],
    getReceiptByInvoiceIds: (invoiceIds = [], params = {}) => [
      '/receipt/by-invoice-ids',
      { invoice_ids: invoiceIds },
      { params },
    ],
    createAdHocCreditNote: (body = {}) => [
      '/credit-debit-note/create-adhoc-credit-note',
      body,
    ],
    getBillableItems: (body = {}, params = {}) => [
      '/billable/billable-items',
      body,
      { params },
    ],
    cancelAdvancePaymentReceipt: (body = {}) => [
      '/receipt/cancel-advance-payment-receipt',
      body,
    ],
    getEcdaRegistrationInvoice: registrationID => [
      `/ecda-registration-payment/invoice-by-registration?registrationID=${registrationID}`,
    ],
    getApplicableRegChildDiscounts: (regChildId, params = {}) => [
      `/discount/applicable-by-reg-child-id/${regChildId}`,
      params,
    ],
    getDiscountItemGroupByIds: (ids = []) => [
      '/discount-item-group/get-by-ids',
      {
        ids,
      },
      {
        params: { page: 1, perPage: ids?.length },
      },
    ],
    getAllDiscountItemGroup: (body = {}, params = {}) => [
      '/discount-item-group/get-all',
      body,
      { params },
    ],
    getAllDiscountItemGroupCentreRelations: (discountGroupIds = []) => [
      '/discount-item-group/get-all-centre-relations',
      {
        discount_item_group_ids: discountGroupIds,
      },
    ],
    getRegistrationDraftMonthlyFeeInvoice: registrationID =>
      `/registration-payment/fee-invoice-by-registration?registrationID=${registrationID}`,
    getApplicableDiscountsEcda: (regEcdaChild, params = {}) => [
      `/discount/applicable-by-ecda-reg-child-id/${regEcdaChild}`,
      params,
    ],
    changeObsoleteDateChildDiscount: '/discount/change-obsolete-date',
    findAllPurchaseItem: '/billable/purchase-items',
    searchInvoice: 'search/invoice',
    searchFinance: 'search/finance',
    validateProgramBillingRequest: '/program-billing/validate',
    findAllProgramBillingUpload: 'program-billing/find-all',
    getFeeTiersByLevelByCentre: '/fee/get-fee-tiers-level-by-centre',
    getChildFeeTierForChild: 'fee/get-child-fee-tier',
    getAllFeeTiers: 'fee/fee-tiers',
    getUpcomingChildFeeTier: '/fee/get-upcoming-child-fee-tier',
    getProgramBillingUploadURL: 'program-billing/upload-url',
    createProgramBillingRequest: 'program-billing/create',
    findAllChildActiveSubsidies: (childId, params = {}) =>
      `/custom-subsidy/${childId}?${new URLSearchParams(params)}`,
    initiateRefundForCancelledRegistration: (body = {}) => [
      '/refund/initiate-for-cancelled-registration',
      body,
    ],
    findAllCustomSubsidies: (childId, centreID) =>
      `/custom-subsidy/${childId}/billable-items?centre_id=${centreID}`,
    GET_STATEMENT_OF_ACCOUNT: (childId, year) =>
      `/statement-of-account/pdfs/${childId}/${year}`,
    findAllChildHistorySubsidies: (childId, params = {}) =>
      `/custom-subsidy/${childId}/history?${new URLSearchParams(params)}`,
    exportProgramBillingUploadTemplate: 'program-billing/export-template',
    getApplicableFeeTiersForChild: 'fee/get-applicable-fee-tiers-for-child',
    cancelBulkInvoiceRequest: '/bulk-invoice/cancel-request',
    listBulkFeeUploadRequest: '/fee/bulk-fee/list-uploads',
    activateDiscountItemGroup: '/discount-item-group/activate',
    deactivateDiscountItemGroup: '/discount-item-group/deactivate',
    getBulkFeeUploadTemplate: '/fee/bulk-fee/upload/template',
    getBulkFeeUploadURL: '/fee/bulk-fee/upload/url',
    getFinanceDocumentUploadURL: 'finance-document/upload-url',
    findAllUploadedSubsidyFiles: '/adjustment/find-all-uploaded-subsidy-files',
    uploadSubsidyFile: (body = {}) => ['/adjustment/upload-subsidy-file', body],
    downloadProgramBillingMasterFile: '/program-billing/export-master-file',
    GET_REFUND_CONSOLIDATED: (body = {}, params = {}) => [
      '/refund/consolidated',
      body,
      { params },
    ],
    getCurrentChildRefundStatus: '/refund/current-status',
    findAllFeeDraft: '/fee/fee-drafts',
    getFeeDraftItems: '/fee/fee-draft-items',
    getFeeGroups: 'fee/fee-groups',
    uploadBulkFeeFile: (body = {}) => ['/fee/bulk-fee/upload', body],
    getTaxRateAndAmount: 'invoice/get-tax-rate-amount',
    findAllApplicableChildDiscounts: childId =>
      `discount/applicable-by-child-id/${childId}`,
    findAllFeeGroup: '/fee/fee-groups',
    submitFeeDraft: 'fee/submit-fee-draft',
    newFeeDraft: 'fee/create-fee-draft',
    rejectFeeChangeRequest: 'fee/reject-fee-change-request',
    approveFeeChangeRequest: 'fee/approve-fee-change-request',
    addCustomSubsidyToChild: (body = {}) => [
      '/custom-subsidy-creation/add-custom-subsidy-to-child',
      body,
    ],
    voidCustomSubsidy: (body = {}) => [
      '/custom-subsidy-creation/void-custom-subsidy',
      body,
    ],
    getChildFinancialAssistanceStatus: (body = {}) => [
      '/financial-assistance-status/get-child-financial-assistance-status',
      body,
    ],
    getOfflinePaymentModes: 'receipt/get-offline-payment-modes',
    giroSiblingSelectionAction: (body = {}) => [
      '/ocbc-giro/sibling-selection-action',
      body,
    ],
    getSiblingBirthCertificateTempUploadURL: (body = {}, params = {}) => [
      `/ocbc-giro/get-sibling-birth-cert-temp-url?${new URLSearchParams(
        params
      )}`,
      body,
    ],
    findAllCurrentFeeTier: 'fee/current-fee-tiers',
    getFeeByFeeTierIds: 'fee/get-fee-by-fee-tier-ids',
    getRegistrationAccountListing: (reqData = {}) => [
      '/ocbc-giro/get-account-listing',
      { ...reqData },
    ],
    exportGiroApplicationPdf: '/giro/export-giro-application-pdf',
    emailGiroApplicationPdf: '/giro/email-giro-application-pdf',
    generateGiroDeduction: '/giro/generate-giro-deduction',
    generateGiroRefund: '/giro/generate-giro-refund',
    markGenerateGiroRefund: '/refund/mark-generate-giro-refund',
    getLinkpointAwardConfigsByCentreIds:
      '/linkpoint/linkpoint-award-config-by-centre-id',
    getLinkpointAwardConfigDraftsByCentreIds:
      '/linkpoint/linkpoint-award-config-drafts-by-centre-draft-id',
    getApprovedFeeDraftByFeeTierIds:
      'fee/get-approved-fee-draft-by-fee-tier-ids',
    transferChildBalance: (body = {}) => [
      '/balance-transfer/transfer-child-balance',
      body,
    ],
    transferEcdaRegistrationChildBalance: (body = {}) => [
      '/balance-transfer/transfer-ecda-registration-child-balance',
      body,
    ],
    transferRegistrationChildBalance: (body = {}) => [
      '/balance-transfer/transfer-registration-child-balance',
      body,
    ],
    payRegistrationInvoiceByGiro: '/registration-payment/reg-invoice-by-giro',
    getAllAbsentForVoidingSubsidy: (childId, params = {}) =>
      `/custom-subsidy/${childId}/absent-for-voiding?${new URLSearchParams(
        params
      )}`,
    updateFinancialAssistanceStatus: (body = {}) => [
      '/financial-assistance-status/update-child-financial-assistance-status',
      body,
    ],
    findAllUpcomingFeeTier: 'fee/upcoming-fee-tiers',
    cancelFeeChangeRequest: 'fee/cancel-fee-change-request',
    uploadGiroFile: (body = {}) => ['/giro/upload-file', body],
    saveEcdaRegGiroApplication: (body = {}) => [
      '/giro/save-ecda-reg-giro-application',
      body,
    ],
    getTradeDebtNotificationConfigByChildId: childId =>
      `/trade-debt/child-trade-debt-notification-config/${childId}`,
    saveRegGiroApplication: (body = {}) => [
      '/giro/save-reg-giro-application',
      body,
    ],
    addGiro: (body = {}) => ['/ocbc-giro/add-giro', body],
    saveGiroApplication: (body = {}) => ['/giro/save-giro-application', body],
    approveCustomSubsidy: '/custom-subsidy-creation/approve-custom-subsidy',
    adjustMonthlyFeeInvoice: childID =>
      `/custom-subsidy/${childID}/adjust-monthly-fee-invoice`,
    getSubsidyDebitNoteAmount:
      '/custom-subsidy-creation/estimate-void-custom-subsidy-debit-note-amount',
    getCSSProgrammeByChildId: '/css-programme/by-child-id',
    getCSSPillarNames: '/css-programme/pillar-names',
    addNewFeeTier: body => ['/fee/create-fee-tier', body],
    getEcdaEddaRedirection: (body = {}) => [
      '/edda-aggregator/redirection',
      body,
    ],
    getEgiroDetailsByECDARegChild: ecdaRegistrationChildId =>
      `/edda-aggregator/account-details-by-ecda-registration-child/${ecdaRegistrationChildId}`,
    GET_ADVANCE_PAYMENT_FOR_REGISTRATION:
      '/advance-payment/get-advance-payment-amount-for-registration',
    GET_ADVANCE_PAYMENT_FOR_ECDA_REGISTRATION:
      '/advance-payment/get-advance-payment-amount-for-ecda-registration',
    cancelExportGiroRefund: docId =>
      `/giro/cancel-export-refund?documentId=${docId}`,
    getAllDownloadedFiles: '/giro/get-all-downloaded-files',
    getHHIHistory: (body = {}, params = {}) => [
      '/hhi-history/get-hhi-history',
      body,
      { params },
    ],
    getDocumentUrlPresignedUrl: (body = {}) => [
      '/finance-document/pdf-presigned-url',
      body,
    ],
    getPaymentAccess: (body = {}) => ['/ocbc-giro/get-payment-access', body],
  },
  BANK_ACCOUNT: {
    bankAccountInfoByIDChild: ({ IDChild }) => [
      '/bank-account/get-info-by-child-id',
      { child_id: IDChild },
    ],
    getAccountStateHistoryByAccountIds: ({ bankAccountIds = [] }) => [
      '/bank-account-state-history/by-bank-account-ids',
      { bank_account_ids: bankAccountIds },
    ],
    getBankDocumentByAccountIds: (bankAccountIds = []) => [
      `/document-type/by-bank-account`,
      { bank_account_ids: bankAccountIds },
    ],
    getBankBicCodeByIds: (bicCodeIds = []) => [
      '/bank-bic-code/by-ids',
      { ids: bicCodeIds },
    ],
    checkPreWnrolmentWithdrawal: ({ IDChild }) => [
      '/bank-account/check-pre-enrolment-withdrawal',
      { child_id: IDChild },
    ],
    getBankAccountByChild: ({ regChildId }) => [
      '/bank-account/get-by-registered-child-id',
      { reg_child_id: regChildId },
    ],
    getAllBankBicCode: params => ['/bank-bic-code', { params }],
    getBankAccountStatusChangeReasons: ({ currentStatus, selectedStatus }) => [
      '/bank-account/get-status-change-reasons',
      { current_status: currentStatus, selected_status: selectedStatus },
    ],
    updateBankAccountBillRefNumber: ({ IDBankAccount, referenceNumber }) => [
      '/bank-account/update-bank-account-bill-reference-number',
      { bank_account_id: IDBankAccount, reference_number: referenceNumber },
    ],
    updateBankAccountStatus: ({ bankAccountID, status, remarks, schoolID }) => [
      '/bank-account/update-status',
      { bank_account_id: bankAccountID, status, remarks, school_id: schoolID },
    ],
    addBankAccountForRefund: '/bank-account/add-for-refund',
    getByChildIds: (childIds = [], params = {}) => [
      '/bank-account/get-by-child-ids',
      { child_ids: childIds },
      { params },
    ],
  },
  SCHOOL: {
    getDebtWriteOffReasonCodes: () => [`/code/debt-writeoff-reasons`],
    getCodesByCodeId: (ids = []) => ['/code/get-code-by-ids', { ids }],
    getAllBusinessEntities: () => ['/business-entity'],
    getAllSchoolConfigs: id => `/public/school/config/${id}`,
    updateSchoolConfig: (id, body = {}) => [`/config/${id}`, body],
    getAllLevelConfigs: (filters = {}, params = {}) => [
      '/level/find-all-levels',
      filters,
      { params },
    ],
    getConfigByCategory: (schoolId, category = '') => [
      '/public/code/config/category',
      {
        category,
        filter: {
          schools_ids: [schoolId],
        },
      },
    ],
    getNextLevelsByLevelIds: (levelIds = []) => [
      '/level/get-next-level-of',
      { levelIDs: levelIds.join(',') },
    ],
    getSchoolById: id => `/${id}`,
    getCurrentSystemAnnouncement: target =>
      `/system-announcements/current?targetId=${target}`,
    getAllSystemAnnouncements: (params = {}) => {
      const queryParams = new URLSearchParams({
        page: params.page || DEFAULT_PAGE,
        perPage: params.perPage || DEFAULT_ITEMS_PER_PAGE,
        ...params,
      });
      return `/system-announcements?${queryParams}`;
    },
    getSystemAnnouncementTargetMappings: (
      announcementIds = [],
      params = {}
    ) => {
      const queryParams = new URLSearchParams({
        announcement_ids: announcementIds.join(','),
        page: params.page || DEFAULT_PAGE,
        perPage: params.perPage || DEFAULT_ITEMS_PER_PAGE,
        ...params,
      });
      return `/system-announcements/target-mappings?${queryParams}`;
    },
    getSystemAnnouncementTargets: (targetIds = [], params = {}) => {
      const queryParams = new URLSearchParams({
        ...(targetIds.length > 0 && { target_ids: targetIds.join(',') }),
        page: params.page || DEFAULT_PAGE,
        perPage: params.perPage || DEFAULT_ITEMS_PER_PAGE,
        ...params,
      });
      return `/system-announcements/targets?${queryParams}`;
    },
    getAllSystemAnnouncementTargets: `/system-announcements/targets`,
    getCancellationReasonList: 'cancellation-reason/list',
    getRegistrationCancellationDetail: (body = {}) => [
      '/cancellation-reason/registrations',
      body,
    ],
    getConfigByCategories: '/public/code/config/categories',
    getHHIIncomeLevelOptions: '/code/hhi-income-levels',
    getLevelsForSchool: '/level/school',
    insertOrUpdateLevel: (body = {}) => ['/level/insert-or-update', body],
    deleteLevel: id => `/level/${id}`,
    getECDACombinedWorkingStatus: () => '/code/ecda-combined-working-status',
    updateSystemAnnouncement: id => `/system-announcements/${id}`,
    getLifeSgExceptionList: '/code/ecda-lifesg-exception-list',
    getLorAgencyOptions: '/code/lor-agency-options',
    deleteSystemAnnouncement: id => `/system-announcements/${id}`,
    createSystemAnnouncements: (reqBody = {}) => [
      '/system-announcements',
      reqBody,
    ],
  },
  INVOICE: {
    findAllInvoice: ({ filter = {}, params = {} }) => [
      '/invoice/find-all-invoice',
      { ...filter },
      { params },
    ],
    getInvoiceByChildId: (reqBody = {}, params = {}) => [
      '/invoice/get-by-child-id',
      { ...reqBody },
      { params },
    ],
    getInvoiceItemsByInvoiceIds: (reqBody = {}) => [
      '/invoice/invoice-items/by-invoice-ids',
      { ...reqBody },
    ],
    getBillableItemsByIds: (reqBody = {}) => [
      '/invoice/billable-items/by-ids',
      { ...reqBody },
    ],
    getCreditDebitNotesByInvoiceIds: ({ invoiceIds = [] }) => [
      '/credit-debit-note/get-by-invoice-ids',
      { invoice_ids: invoiceIds },
    ],
    createOfflineInvoice: (reqBody = {}) => [
      '/invoice/create-offline-invoice',
      { ...reqBody },
    ],
    validateBulkInvoiceRequest: filePath => [
      `/bulk-invoice/validate-request`,
      { file_path: filePath },
    ],
    getBulkInvoiceTemplate: () => `/bulk-invoice/template`,
    createBulkInvoiceRequest: (reqBody = {}) => [
      `/bulk-invoice/create-request`,
      { ...reqBody },
    ],
    getBulkInvoiceUploadURL: (body = {}) => [
      '/bulk-invoice/file-upload-url',
      body,
    ],
  },
  CENTRE_WAITLIST: {
    getLeadById: ({ ID }) => [`/leads/${ID}`],
    getMarketingConsentById: ({ ID }) => [`/marketing-consent/${ID}`],
    getMCBusinessEntitiesById: ({ ID }) => [
      `/marketing-consent/mc-business-entity/by-mc-id/${ID}`,
    ],
    getLeadsByChildId: ({ ID }) => [`/leads/by-lead-child/${ID}`],
    getAllLeads: (reqBody = {}, params = {}) => [
      '/leads/get-by-filter',
      { ...reqBody },
      { params },
    ],
    getAllTags: () => ['/tags'],
    updateLeadTags: (leadID, reqBody = {}) => [
      `/leads/${leadID}/update-lead-tags`,
      { ...reqBody },
    ],
    offerLead: ({ centreID, leadID, bypassExceeding } = {}) => [
      `/leads/${leadID}/offer`,
      {
        centre_id: centreID,
        ...(bypassExceeding && { bypass_exceeding: bypassExceeding }),
      },
    ],
    approveLead: (leadID, reqBody = {}) => [`/leads/${leadID}/assign`, reqBody],
    cancelLead: (leadID, reqBody = {}) => [
      `/leads/${leadID}/cancel-lead`,
      {
        cancel_reason: reqBody?.reasonID,
        centre_id: reqBody?.centreID,
        ...(reqBody?.bypassExceeding && {
          bypass_exceeding: reqBody?.bypassExceeding,
        }),
        remarks: reqBody?.remarks,
      },
    ],
    getLeadActivityLogByLeadChild: leadChildId =>
      `/leads/lead-child/${leadChildId}/lead-activity-logs`,
    getLeadTagByLeadId: (leadIDs = []) => [
      `/leads/lead-tags`,
      { leadIDs: leadIDs?.join(',') },
    ],
    updateLeadChildDetails: (leadChildId, reqBody = {}) => [
      `/leads/lead-child/${leadChildId}`,
      { ...reqBody },
    ],
    updateLeadEnquiryDetails: (leadId, reqBody = {}) => [
      `/leads/${leadId}/update-lead-enquiry`,
      { ...reqBody },
    ],
    getLeadOfferedToTransferDraft: transferDraftID =>
      `/leads/lead-offered-to-transfer-draft/${transferDraftID}`,
    addInteraction: (leadChildID, reqBody = {}) => [
      `/leads/lead-child/${leadChildID}/interactions`,
      { ...reqBody },
    ],
    getModifiedLeadVacancy: (reqBody = {}) => [
      '/leads/get-modified-lead-vacancy',
      reqBody,
    ],
  },
  USER: {
    getUserById: ({ ID }) => [`/${ID}`],
    getUserByIds: (body = {}) => ['/get-by-ids', body],
    getAllPOCUsers: (params = {}) => ['/staff/poc-staff', { ...params }],
    addUpdateSpouse: (body = {}) => ['/parent/add-or-update-spouse', body],
    removeChildSpouse: (body = {}) => ['/parent/remove-child-spouse', body],
    getStaffUserByStaffIds: (staffIds = []) => [
      `/staff/staff-user-by-staff-ids`,
      { staff_ids: staffIds, active: true },
      { params: { page: 1, perPage: staffIds?.length } },
    ],
    getMarketingConsentUserByFkMCUser: id => `/marketing-consent-user/${id}`,
    leadChildLastUpdatedBy: (leadChildIds = []) => [
      `/leads/lead-child/last-updated-by-user`,
      { leadChildIDs: leadChildIds?.join(',') },
    ],
    leadLastUpdatedBy: (leadIds = []) => [
      `/leads/last-updated-by-user`,
      { leadIDs: leadIds?.join(',') },
    ],
    userByTcAcknowledgeBy: (body = {}) => ['/user-by-tc-acknowledge-by', body],
    getStaffFromStaffLoader: id => `get-staff-from-staff-loader/${id}`,
    me: '/me',
    getParentByUserId: userId => `/parent/user/${userId}`,
    addOrUpdateParentAddress: '/parent/add-or-update-parent-address',
    updateParentNationality: '/parent/update-parent-nationality',
    updateParentMaritalStatus: '/parent/update-parent-marital-status',
    updateParentWorkingStatus: '/parent/update-parent-working-status',
    updateParentName: '/parent/update-parent-name',
    updateParentIdentificationNo: '/parent/update-parent-identification-number',
    updateParentBirthdate: '/parent/update-parent-birthdate',
    updateParentRelation: '/parent/update-parent-relation',
    updateParentEmailOrMobile: (reqBody = {}) => [
      `/parent/update-parent-email-or-mobile`,
      { ...reqBody },
    ],
    updateStaff: staffId => `staff/${staffId}/update-with-extra-info`,
    getAddressesByUserIds: (userIDs = []) => [
      '/address/get-by-user-ids',
      { user_ids: userIDs },
    ],
    getParentByFilter: '/parent/get-by-filter',
    findAllStaff: '/staff/find-all-staff',
    getStaffByUserId: id => `/staff/user/${id}`,
    findAllReportingStaff: (reqBody = {}, params = {}) => [
      '/staff/find-all-reporting-staff',
      { ...reqBody },
      { params },
    ],
    getADUserByEmail: email => `/ad-user-by-email?email=${email}`,
    getADUsersByName: name =>
      `/ad-users-by-name?name=${encodeURIComponent(name)}`,
    getLinkPassUserInfoFromClaim: '/linkpass/linkpass-user-info-from-claim',
    getLinkpassSn2UserInfo: (body = {}) => [
      '/linkpass/linkpass-user-info',
      { ...body },
    ],
    linkUserWithLinkPassLogin: (body = {}) => [
      '/linkpass/link-user-with-linkpass-login',
      { ...body },
    ],
    registerQithLinkPassInfo: (body = {}) => [
      '/linkpass/register-with-linkpass-info',
      { ...body },
    ],
  },
  CENTRE: {
    getSuggestPrograms: (reqBody = {}) => [
      '/program/suggest-programs',
      { ...reqBody },
    ],
    getAddressesByCentreIds: (centreIDs = []) => [
      '/address/get-by-centre-ids',
      { centreIDs: centreIDs?.join(','), page: 1, perPage: centreIDs?.length },
    ],
    getAvailableVacancy: (reqBody = {}) => [
      '/capacity-summary/get-available-vacancy',
      { ...reqBody },
    ],
    getAllPrograms: (reqBody = {}) => [
      '/program/find-all-program',
      { ...reqBody },
    ],
    getHolidayOfYearForCalendar: ({ centreIds = [], year }) => [
      '/holiday/get-holidays-of-year-for-calendar',
      {
        id_centres: centreIds,
        year,
      },
    ],
    getAccessibleCentresForModule: (reqBody = {}, params = {}) => [
      `/get-accessible-centres-for-module`,
      { ...reqBody },
      { params },
    ],
    getCentreByFilters: (body = {}, params = {}) => [
      '/get-centres-by-filter',
      body,
      { params },
    ],
    getCentreLevelByCentreIds: (centreIds = []) => [
      '/centre-level/get-by-centre-ids',
      { centre_ids: centreIds },
      { params: { page: 1, perPage: centreIds?.length } },
    ],
    getNearbyPostalCodeByCentreIds: (centreIds = []) => [
      '/centre-nearby-postcode/get-by-centre-ids',
      { centre_ids: centreIds },
      {
        params: {
          page: 1,
          perPage: centreIds?.length,
        },
      },
    ],
    getCentreLevelProgramByFilter: (
      { centreIds = [], ...body } = {},
      params = {}
    ) => [
      '/centre-level-program/get-by-filter',
      { centre_ids: centreIds, ...body },
      { params: { page: 1, perPage: centreIds?.length, ...params } },
    ],
    getCentreWorkplaceByCentreIds: (centreIds = []) => [
      '/centre-workplace/get-by-centre-ids',
      { centreIds },
      { params: { page: 1, perPage: centreIds?.length } },
    ],
    getCentreDraftWorkplaces: (centreDraftIds = []) => [
      '/centre-draft/workplaces',
      { centre_draft_ids: centreDraftIds },
    ],
    getCentreDraftAddresses: (centreDraftIds = []) => [
      '/centre-draft/addresses',
      { centre_draft_ids: centreDraftIds },
    ],
    getCentreDraftsByFilter: (body = {}, params = {}) => [
      '/centre-draft/find-all-for-school',
      { ...body },
      { params },
    ],
    getCentreDraftNearbyPostcodes: (centreDraftIds = []) => [
      '/centre-draft/nearby-postcodes',
      { centre_draft_ids: centreDraftIds },
    ],
    getCentreDraftLevels: (centreDraftIds = []) => [
      '/centre-draft/levels',
      { centre_draft_ids: centreDraftIds },
    ],
    getCentreDraftLevelPrograms: (centreDraftIds = []) => [
      '/centre-draft/level-programs',
      { centre_draft_ids: centreDraftIds },
    ],
    getCentreHolidaysOfYear: '/holiday/get-centre-holidays-of-year',
    findAllCalendarEvent: '/visit/find-all-calendar-event',
    findAllCentreLevel: '/centre-level/get-centre-level-by-centre-ids',
    getTeacherListOnInput: '/centre-teacher/teacher-list-on-input',
    createEnrollmentPlanningRequest: '/enrolment-planning',
    postCentreDocuments: '/centre-document/save-centre-document',
    updateHoliday: holidayId => `/holiday/${holidayId}`,
    getEnrolmentPlanningUtilisation: '/enrolment-planning/utilisation',
    rejectCustomSubsidy: (body = {}) => [
      '/custom-subsidy-creation/reject-custom-subsidy',
      body,
    ],
    getCentreDocumentCategories:
      '/centre-document/get-centre-document-categories-config',
    getCentreDocumentUploadURLDocumentCategoryConfig:
      '/centre-document/upload-url/get-centre-document-upload-url-document-category-config',
    submitCentreDraft: centreId => `/centre-draft/${centreId}/submit`,
    upsertCentreDraft: (body = {}) => ['/centre-draft/upsert', body],
    upsertCentre: (body = {}) => ['/upsert', body],
    getListEnrollmentPlanningActivityLog: '/capacity-draft/get-by-filter',
    createHoliday: '/holiday',
    deleteSchoolCentreDraft: centreId => `/centre-draft/${centreId}`,
    cancelSchoolCentreDraft: centreId => `/centre-draft/${centreId}/cancel`,
    capacityDraftsGroupedByCenter: '/capacity-draft/grouped-by-center',
    getCentreActivityLogs: (body = {}, params = {}) => [
      '/centre-snapshot/find-by-centre',
      body,
      { params },
    ],
    removeHoliday: holidayId => `/holiday/${holidayId}`,
    addCalendarEvent: (body = {}) => ['/visit/add-calendar-event', body],
  },
  ENROLMENT_PLANNING: {
    getEnrolmentDates: (reqBody = {}) => [
      '/enrolment-planning/get-enrolment-dates',
      { ...reqBody },
    ],
    getEnrolmentPlansByYear: (reqBody = {}, params = {}) => [
      '/enrolment-planning/get-enrolment-plans-by-year',
      { ...reqBody },
      { params },
    ],
    getListEnrollmentPlanningRequests:
      '/enrolment-planning/get-change-requests',
    approveEnrollmentPlan: '/enrolment-planning/approve',
    rejectEnrollmentPlan: '/enrolment-planning/reject',
  },
  FORM: {
    getFormByRegistrationId: id => `/form/get-by-registration-id/${id}`,
    getParticipantsByFormIds: ({ formIDs = [] }) => [
      '/form-participant/get-by-form-ids',
      { formIDs: formIDs?.join(',') },
    ],
    getFormsByFilter: '/form/get-by-filter',
  },
  CHILD: {
    getApplicantByChildIds: (childIDs = []) => [
      '/child-relation/get-applicant-of-child-by-child-ids',
      { childIDs: childIDs?.join(',') },
    ],
    getApplicantsOfChild: childId =>
      `/child-relation/get-applicants-of-child/${childId}`,
    switchMainApplicant: (body = {}) => [
      '/child-relation/switch-child-main-applicant',
      body,
    ],
    updateChildParticular: (body = {}) => ['/update-child-particular', body],
    approveECDARegDocument: (body = {}) => [
      '/ecda-registration-document/approve',
      body,
    ],
    rejectECDARegDocument: (body = {}) => [
      '/ecda-registration-document/reject',
      body,
    ],
    skipECDARegDocument: (body = {}) => [
      '/ecda-registration-document/skip',
      body,
    ],
    skipGiroForECDA: registrationId =>
      `/ecda-registration-form/skip-giro/${registrationId}`,
    getECDARequiredDocuments: ecdaRegId =>
      `/ecda-registration-document/required/${ecdaRegId}`,
    getDocumentTypeConfigs: ids => [
      '/document-type-config/get-by-ids',
      { ids: ids?.join(','), page: 1, perPage: ids?.length },
    ],
    getDocumentTypeConfigsByFk: () =>
      '/document-type-config/by-fk-document-type-config',
    getDocumentTagsByDocumentTypeConfigIds: (docTypeConfigIds = []) => [
      '/document-tag/get-document-tags-by-document-type-ids',
      { document_type_ids: docTypeConfigIds },
    ],
    getEmergencyContact: childId =>
      `/child-attribute/${childId}/emergency-contact`,
    getChildHealthByChildId: (childIDs = []) => [
      `/child-attribute/get-child-heath`,
      { child_ids: childIDs },
    ],
    getMeasurementsForChildByFromAndToDate: (body = {}) => [
      '/child-health/get-measurements-for-child-by-from-and-to-date',
      body,
    ],
    revertECDARegDocument: (body = {}) => [
      '/ecda-registration-document/revert',
      body,
    ],
    getDocumentsByIds: (docIds = []) => [
      '/document/multiple-documents',
      {
        document_ids: docIds,
      },
    ],
    getParentRelationById: parentId =>
      `/child-relation/get-relation-from-parent/${parentId}`,
    findAllEnquiry: '/enquiry/find-all',
    addOrUpdateEmergencyContact: childId =>
      `/child-attribute/${childId}/emergency-contact`,
    addChildActivityLog: '/child-activity-log',
    saveECDARegistrationGiroDocument: '/ecda-registration-document/save-giro',
    getCurrentChildLevel: (childIds = []) => [
      `/child-level/get-current-child-level-by-child-ids?${new URLSearchParams({
        page: 1,
        perPage: childIds?.length,
      })}`,
      { child_ids: childIds },
    ],
    getEnrolmentStatusByChildIds: (childIds = []) => [
      '/child-enrolment-status/get-by-child-ids',
      { child_ids: childIds },
    ],
    getChildLevelsByChildIds: (childIds = []) => [
      '/child-level/get-child-levels-by-filter',
      { child_id: [{ eq: childIds }] },
    ],
    getOfflineConsentFormByRegistration: registrationID =>
      `/document/get-offline-consent-form/${registrationID}`,
    getRequiredRegDocuments: registrationId =>
      `/registration-document/required/${registrationId}`,
    approveRegDocument: '/registration-document/approve',
    rejectRegDocument: '/registration-document/reject',
    skipRegDocument: '/registration-document/skip',
    revertRegDocument: '/registration-document/revert',
    removeRegDocument: '/registration-document/remove',
    saveRegistrationGiroDocument: 'registration-document/save-giro',
    getGiroFormUploadURL: '/registration-document/get-giro-form-upload-url',
    childRelationsByUserIds: '/child-relation/get-by-user-ids',
    assignChildrenToClass: '/child-class/assign-children-to-class',
    updateChildName: '/update-child-name',
    updateChildBC: '/update-child-bc',
    updateChildNationality: '/update-child-nationality',
    updateChildGender: '/update-child-gender',
    updateChildRace: '/update-child-race',
    updateEnrolmentDateEnrolledChild: '/update-enrolled-child-enrolment-date',
    updateChildProgramType: '/update-child-program-type',
    updateKidStartFundingForChild: '/update-child-starting-funding',
    currentChildClasses: '/child-class/current',
    upcomingChildClasses: '/child-class/upcoming',
    getChildUpcomingClassesByChildIds: '/child-class/upcoming-by-child-id',
    getTransferDrafts: '/transfer-draft/get-by-filter',
    getTransferDraftItems: '/transfer-draft-item/filter',
    getWithdrawalDraftItems: '/withdrawal/draft-item/filter',
    getChildLevelsByFilter: '/child-level/get-child-levels-by-filter',
    getEcdaGiroFormUploadURL:
      '/ecda-registration-document/get-ecda-giro-form-upload-url',
    getCdaAccountStatementUploadURL:
      '/registration-document/get-cda-account-statement-upload-url',
    listAllEnrolledChildDocuments:
      '/document-type/list-all-enrolled-child-documents',
    updateChildHealthInfo: (childId, body = {}) => [
      `/child-attribute/${childId}/health-info`,
      body,
    ],
    findAllChildActivityLogs:
      '/child-activity-log/find-all-child-activity-log-by-filter',
    saveEnrolledChildDocument: (body = {}) => [
      `/document-type/save-enrolled-child-document`,
      body,
    ],
    saveDocument: (body = {}) => ['/document/save', body],
    getDocumentTagsByFilter: (body = {}) => [
      '/document-tag/get-document-tags-by-filter',
      body,
    ],
    getChildPhotoUploadUrl: (body = {}) => [
      '/upload-url/child-photo-upload-url',
      body,
    ],
    getDocumentTypeByFilter: 'document-type/document-type-by-filter',
    getGetGiroFormUploadURL: (body = {}) => [
      '/registration-document/get-giro-form-upload-url',
      body,
    ],
    getTempWithdrawalEffectiveToDate:
      '/temporary-withdrawal/get-effective-to-date',
    getWithdrawalDefaultRefundAmount: '/withdrawal/default-refund-amount',
    getDocumentTagsByFilters: '/document-tag/get-document-tags-by-filter',
    getDocumentTypesByFilters: '/document-type/document-type-by-filter',
    getChildLevelsByChildId: '/child-level/get-child-level-by-child-id',
    getChildActivityLogsByFilter:
      '/child-activity-log/find-all-child-activity-log-by-filter',
    getWithdrawlsByFilter: '/withdrawal/get-by-filter',
    getChildCurrentLevelAndCentreByChildIds:
      '/child-level/get-current-child-level-and-centre-by-child-ids',
    getLastChildLevelByChildId: childId =>
      `/child-level/get-last-child-level?childId=${childId}`,
    getUpcomingLevelByChildIds: childIds =>
      `/child-level/upcoming-by-child-ids?child_ids=${childIds.join(',')}`,
    getEnquiriesByChildId: '/enquiry/get-by-child-id',
    getTemporaryWithdrawalByChildId: childId =>
      `/temporary-withdrawal/child/${childId}`,
    getWithdrawalDraftItemsByChildId: childId =>
      `/withdrawal/draft-item/child/${childId}`,
    getWithdrawalDraftItemByDraftId: draftId =>
      `/withdrawal/draft-item/${draftId}`,
    getChildCurrentEstimatedPromotionDate: childId =>
      `/promotion/${childId}/current-estimated-date`,
    getChildEffectiveFrom: '/effective-date',
    getChildEnrolmentDate: childId =>
      `/child-level/get-child-enrolment-date/${childId}`,
    getChildProgramTypeUpdateEffectiveFrom: childId =>
      `/child-level/get-program-type-update-effective-from/${childId}`,
    getChildSiblingsByChildId: childId =>
      `/get-child-siblings-by-child-id/${childId}`,
    getEstimatedWithdrawalEffectiveDateList: childId =>
      `/withdrawal/estimated-withdrawal-effective-dates?childId=${childId}`,
    getPastChildrenData: (body = {}, params = {}) => [
      `/get-past-children-data`,
      { ...body },
      { params },
    ],
    getUpcomingClassByChildIds: (childIds = []) =>
      `/child-class/upcoming-by-child-ids?${new URLSearchParams({
        child_ids: childIds,
      })}`,
    submitTemporaryWithdrawalRequest:
      '/temporary-withdrawal/new-temporary-withdrawal-request',
    getTransferDraftsPendingApprovals: 'transfer-draft/get-pending-approvals',
    getWithdrawalDrafts: 'withdrawal/withdrawal-draft-by-filter',
    getPendingForm2ESignatureChildren: '/get-pending-form2-esignature-children',
    getWithdrawalDraftActivityLogs: '/withdrawal/draft-activity/logs',
    GET_ALL_CHILD: '/get-all-child',
    GET_CHILDS_BY_FILTER: '/get-childs-by-filter',
    cancelRetainedChild: '/cancel-retain-child',
    getSiblingBirthCertificateUploadURL: (body = {}) => [
      '/registration-document/get-sibling-birth-certificate-upload-url',
      body,
    ],
    approveTransferRequestByDestinationCentreStaff: (reqBody = {}) => [
      '/transfer/approve-by-destination-centre-staff',
      reqBody,
    ],
    rejectTransferRequestByDestinationCentreStaff: (reqBody = {}) => [
      '/transfer/reject-by-destination-centre-staff',
      reqBody,
    ],
    getDownloadMeasurementTemplate: (classID, levelID) =>
      `/measurement-template/${classID}/${levelID}`,
    getDocumentUploadUrlByDocumentTypeConfig: (reqBody = {}) => [
      '/document-type-config/get-document-upload-url-by-document-type-config',
      reqBody,
    ],
    cancelTransferRequestByUser: '/transfer/cancel-by-user',
    getChildrenData: (body = {}) => ['/get-children-data', body],
    updateChildByFields: (childId, body = {}) => [`/${childId}`, body],
    getChildrenToAssignToClass: (body = {}, params = {}) => [
      '/get-children-to-assign-to-class',
      { ...body },
      { params },
    ],
    getChildEnrollmentDateByChildIds: (childIds = []) => [
      '/promotion/current-estimated-date/bulk',
      { child_ids: childIds },
    ],
    getChildByIds: (childIds = []) => ['/get-by-ids', { child_ids: childIds }],
    getEnrolmentDate: (childIds = []) => [
      '/child-level/get-child-enrolment-dates',
      { childIds },
    ],
    getChildRelationsByChildIds: (childIds = []) => [
      '/child-relation/get-by-child-ids',
      { child_ids: childIds },
    ],
    getChildLevelsByChildIdsAt: (body = {}) => [
      '/child-level/get-level-by-child-ids',
      body,
    ],
    getMeasurementsByForChild: '/child-health/get-measurements-for-childs',
    promoteChildrenAndAssignClasses:
      '/promotion/promote-children-and-assign-class',
    cancelPromotion: body => ['/promotion/cancel-promotion', body],
    retainChild: body => ['/retain-child', body],
    newTransferRequest: '/transfer',
  },
  REFUND: {
    createAdhocChildRefund: (reqBody = {}) => [
      `/refund/adhoc-child-refund`,
      { ...reqBody },
    ],
    getRegRefundChildBalance: (reqBody = {}, params = {}) => [
      `/refund/registration-child-balance`,
      { ...reqBody },
      { params },
    ],
    initiateRefundForCancelledEcdaRegistration: (reqBody = {}) => [
      `/refund/initiate-for-cancelled-ecda-registration`,
      { ...reqBody },
    ],
  },
  RECEIPT: {
    createAdvancePaymentReceiptForRegistration: (reqBody = {}) => [
      `/receipt/create-advance-payment-receipt-for-registration`,
      { ...reqBody },
    ],
    createAdvancePaymentReceiptForEcdaRegistration: (reqBody = {}) => [
      `/receipt/create-advance-payment-receipt-for-ecda-registration`,
      { ...reqBody },
    ],
  },
  CLASS: {
    getAllClassInfo: (reqBody = {}, params = {}) => [
      '/get-all-class-info',
      { ...reqBody },
      { params },
    ],
    getAllClassInfoForChild: (reqBody = {}, params = {}) => [
      '/get-all-class-info-for-child',
      { ...reqBody },
      { params },
    ],
    updateClassDetails: classId => `/${classId}/update-details`,
    classTeachersByIds: (classTeacherIds = []) => [
      '/class-teacher/get-by-ids',
      { class_teacher_ids: classTeacherIds },
    ],
    getClassPhotoUploadUrl: '/upload-url/class-photo-upload-url',
    getClassMeasurementUploadUrl: '/upload-url/class-measurement-upload-url',
    createNewClass: '/create-new-class',
  },
  GUARDIAN: {
    updateChildGuardian: (reqBody = {}) => [
      `/update-child-guardian-v2`,
      { ...reqBody },
    ],
    getAllGuardianV2: (body = {}, params = {}) => [
      `/get-list`,
      { ...body },
      { params },
    ],
    getCentreVerifications: (guardianIds = []) => [
      `/guardian-centre-verification/get-by-guardian-ids`,
      { guardian_ids: guardianIds },
    ],
    getGuardianChildRelations: (guardianIds = [], params = {}) => [
      `/guardian-child-relation/get-by-guardian-ids`,
      { guardian_ids: guardianIds },
      { params },
    ],
    getGuardianActivityLog: (guardianID, params = {}) =>
      `/${guardianID}/activity-log?${new URLSearchParams(params)}`,
  },
  AUTH: {
    login: (body = {}) => ['/login', body],
    forgotPassword: email => ['/forget-password', { email }],
    getSsoUrl: '/login-url',
    validateOtp: (body = {}) => ['/public/validate-otp', body],
    resetPassword: (body = {}) => ['/reset-password', body],
  },
  UAC: {
    getSidemenuConfig: fkSchool => [
      '/navigation/sidebar-menu',
      {
        fk_school: {
          eq: [fkSchool],
        },
      },
    ],
    updateRole: (roleId, body = {}) => [
      `/role/${roleId}/update-with-module-relations`,
      body,
    ],
    getMeAccessScope: '/user-access-control/me/access-scope',
    getMeAccessControlByUserId: userId => `/user-access-control/user/${userId}`,
    getUserRoleRelationsByUserId: userId =>
      `/user-role-relation/user/${userId}`,
    getRolesByIds: (roleIds = []) => [
      '/role/get-by-ids',
      { role_ids: roleIds },
    ],
    getRoleTemplatesByRoleId: roleId => `/role-template/role/${roleId}`,
    getRoleTemplatesByFilter: (filter = {}) => [
      '/role-template/by-filter',
      filter,
    ],
    getModuleCategoriesByRoleTemplateIds: (roleTemplateIds = []) => {
      const ids = Array.isArray(roleTemplateIds)
        ? roleTemplateIds.join(',')
        : roleTemplateIds;
      return `/module-category/by-role-template-ids${
        ids ? `?role_template_ids=${ids}` : ''
      }`;
    },
    getRolesByUserIds: '/role/get-role-by-user-ids',
    getAllModuleCategory: '/module-category',
    getUserAccessControlByUsers:
      '/user-access-control/get-user-access-control-by-users',
    findRoleBySchool: '/role/find-role-by-school',
    findRoleForUserCreation: '/role/find-role-for-user-creation',
    addRole: (body = {}) => ['/role/add-role', body],
  },
  STAFF: {
    addNewStaff: (body = {}) => ['/staff/add-new-staff', body],
  },
  TRANSACTION: {
    getTransactionInstance: transactionInstanceId =>
      `/${transactionInstanceId}`,
  },
};

// Axios instance for notification service, will update when MS supports API Gateway
export const notificationMsInstance = AxiosHelper({
  baseURL: process.env.REACT_APP_MS_NOTIFICATION_URL,
});

export const healthAttendanceMsInstance = () =>
  AxiosHelper({
    baseURL: process.env.REACT_APP_MS_HEALTH_ATTENDANCE_URL,
  });

export const reportSerivce = () =>
  AxiosHelper({
    baseURL: process.env.REACT_APP_MS_REPORT_SVC_URL,
  });

export const centreSerivce = () =>
  AxiosHelper({
    baseURL: process.env.REACT_APP_MS_CENTRE_SVC_URL,
  });

export const classOpsService = () =>
  AxiosHelper({ baseURL: process.env.REACT_APP_MS_CLASS_OPS_SVC_URL });

export const userService = () =>
  AxiosHelper({ baseURL: process.env.REACT_APP_MS_USER_SVC_URL });

export const classService = () =>
  AxiosHelper({ baseURL: process.env.REACT_APP_MS_CLASS_SVC_URL });

export const schoolService = () =>
  AxiosHelper({ baseURL: process.env.REACT_APP_MS_SCHOOL_SVC_URL });

export const childService = () =>
  AxiosHelper({ baseURL: process.env.REACT_APP_MS_CHILD_SVC_URL });

export const financeService = () =>
  AxiosHelper({ baseURL: process.env.REACT_APP_MS_FINANCE_SVC_URL });

export const onboardingService = () =>
  AxiosHelper({ baseURL: process.env.REACT_APP_MS_ONBOARDING_SVC_URL });

export const guardianService = () =>
  AxiosHelper({ baseURL: process.env.REACT_APP_MS_GUARDIAN_SVC_URL });

export const authService = () =>
  AxiosHelper({ baseURL: process.env.REACT_APP_MS_AUTH_SVC_URL });

export const uacService = () =>
  AxiosHelper({ baseURL: process.env.REACT_APP_MS_UAC_SVC_URL });

export const transactionService = () =>
  AxiosHelper({
    baseURL: process.env.REACT_APP_MS_TRANSACTION_SVC_URL,
  });
